/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquityDto
 */
export interface EquityDto {
    /**
     * 
     * @type {string}
     * @memberof EquityDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EquityDto
     */
    equity: number;
}

export function EquityDtoFromJSON(json: any): EquityDto {
    return EquityDtoFromJSONTyped(json, false);
}

export function EquityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'equity': json['equity'],
    };
}

export function EquityDtoToJSON(value?: EquityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'equity': value.equity,
    };
}

